/// * You can define action creators by usage, by file.
///   http://redux.js.org/docs/basics/Actions.html#action-creators
///   createActions() is enough for almost all use cases
///   document: https://github.com/acdlite/redux-actions#createactionsactionmap-identityactions

import { createActions } from 'redux-actions'
import { REDIRECT_SHARED_LINK, PUT_SHARED_LINK } from './actionTypes'

// supplier actions
export const { updateSaleStatSettings } = createActions({
  UPDATE_SALE_STAT_SETTINGS: settings => settings
})

export const putSharedLink = (linkObj) => {
  return {
    type: PUT_SHARED_LINK,
    payload: linkObj
  }
}

export const redirectSharedLink = ({ key, timeout }) => {
  return {
    type: REDIRECT_SHARED_LINK,
    payload: {
      key,
      timeout
    }
  }
}

export * from './serviceActions'
export * from './common'
